import { Injectable, signal, WritableSignal } from '@angular/core';
import { MessageState } from '@shared/data';

@Injectable({
  providedIn: 'root'
})
export class SimpleMessageService {
  private readonly inlineMessages = new Map<string, WritableSignal<MessageState | null>>();

  getMessageState(key: string): WritableSignal<MessageState | null> {
    let messageState = this.inlineMessages.get(key);
    if (!messageState) {
      messageState = signal<MessageState | null>(null);
      this.inlineMessages.set(key, messageState);
    }
    return messageState;
  }

  sendInlineSuccessMessage(key: string, message: string) {
    this.getMessageState(key).set({ severity: 'success', message: message });
  }

  sendInlineErrorMessage(key: string, message: string) {
    this.getMessageState(key).set({ severity: 'error', message: message });
  }

  sendInlineWarnMessage(key: string, message: string) {
    this.getMessageState(key).set({ severity: 'warn', message: message });
  }

  sendInlineInfoMessage(key: string, message: string) {
    this.getMessageState(key).set({ severity: 'info', message: message });
  }

  /**
   * Clears a single inline message by its key.
   * @param key The key of the message to clear.
   */
  clearInlineMessage(key: string) {
    const messageState = this.inlineMessages.get(key);
    if (messageState) messageState.set(null);
  }

  private resetStates() {
    this.inlineMessages.forEach((messageState) => {
      const messageStateValue = messageState();
      if (messageStateValue) {
        messageState.set(null);
      }
    });
  }
}
